import { Box, Grid2, Typography,Collapse, IconButton } from "@mui/material";
import React, { useState } from "react";
// import aboutUsBg from "../../Images/aboutUsBg.jpg";
// import Image from "../../Images/Partner/Outsourcing/FAQ.png"
import { commonCss } from "../../CssStyle/commonCss";
import { AddCircleOutline, Done, RemoveCircle } from "@mui/icons-material";

const FAQ = () => {
  const [question, setQuestion] = useState({
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
  });
  const questionList = [
    {
      questionName: "What can I expect on our first call?",
      answer:
        "Our initial 30-minute call is all about you—your business, your goals, and your vision. We focus on understanding:",
      listOfAns: true,
      anslist: [
        {
          answer: "Your business, current strategy, and challenges.",
        },
        {
          answer:
            "The objectives and purpose of the product you want to build.",
        },
        {
          answer: "Your expectations, milestones, and success metrics.",
        },
        {
          answer: "How we can best support your digital journey.",
        },
        {
          answer:
            "Our approach to delivering a smart, scalable, and effective solution.",
        },
        {
          answer:
            "A rough timeline and cost estimation based on the initial scope.",
        },
        {
          answer:
            "📞 We respect your time — so we’re flexible to connect via video or voice call, whichever suits you best.",
        },
      ],
      state: "question1",
    },
    {
      questionName: "What should I prepare for the first call?",
      answer:
        "No stress—we’ll guide you through everything! But to make the most of our conversation, it helps if you can share:",
      listOfAns: true,
      anslist: [
        {
          answer: "A brief overview of your business.",
        },
        {
          answer: "The goal you want to achieve with the project.",
        },
        {
          answer: "The problem you're looking to solve.",
        },
        {
          answer: "Who the end-users of the product will be.",
        },
        {
          answer: "Your budget range and expectations.",
        },
      ],
      state: "question2",
    },

    {
      questionName: "What does Solver Thoughts Technologies do?",
      answer:
        "Solver Thoughts Technologies is your one-stop partner for digital transformation. We specialize in building scalable, cutting-edge software solutions using the latest technologies and tools. Our focus is on delivering fully functional, innovative applications—on time—for forward-thinking businesses like yours.",
      listOfAns: false,
      anslist: [],
      state: "question3",
    },
    {
      questionName: "How do we add value to your project?",
      answer:
        "We go beyond just delivering what’s asked—we tailor every solution to fit your specific needs. With a transparent, collaborative approach, we keep you in the loop throughout the process. Plus, we offer proactive guidance on simplifying workflows, avoiding common roadblocks, and leveraging the latest tech trends and best practices to ensure long-term success.",
      listOfAns: false,
      anslist: [],
      state: "question4",
    },

    {
      questionName:
        "Does Solver Thoughts Technologies offer staff outsourcing services?",
      answer:
        "Yes, we do. Solver Thoughts Technologies offers IT Staff Augmentation, Team Outsourcing, and Consulting Services to support your business. Just share your tech resource requirements, and we’ll provide you with top-tier professionals—ready to join remotely or on-site if needed. Whether you need a single expert or an entire team, we’re equipped to handle projects of any scale with precision and expertise.",
      listOfAns: false,
      anslist: [],
      state: "question5",
    },
  ];

  const handleCollapseOpen = (stateName, open) => {
    setQuestion({
      question1: false,
      question2: false,
      question3: false,
      question4: false,
      question5: false,
      [stateName]: open,
    });
  };
  return (
    <Grid2 container spacing={"2rem"}>
      <Grid2
        size={12}
        container
        justifyContent={"center"}
        sx={{
          padding: { xs: "1rem", md: "3rem 2rem" },

          background: `url(/Images/aboutUsBg.jpg)`,
          backgroundSize: "cover",
        }}
      >
        <Box
          sx={{
            // width: "100%",
            // mt: { xs: "35%", sm: "25%", md: "15%", lg: "16%", xl: "5%" },
            mt:"15vh",
            maxWidth: { xs: "auto", xl: "2000px" },
            display: "flex",
            justifyContent: "center",

            // pl: { xs: 0, md:"2rem",lg: "10rem" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", md: "85%" },

              gap: "2rem",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                //  mt: "2%",
                fontSize: { xs: "1.5rem", md: "2rem", lg: "3.3rem" },
                width: "100%",
                fontWeight: 600,
                pl: { xs: "1rem", md: "2rem" },
                //   borderLeft: `7px solid ${commonCss.orange}`,
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography
              sx={{
                fontSize: "1.1rem",
                pl: "0.5rem",
                width: "100%",
                textAlign: "center",
              }}
            >
              We know your time’s valuable. Here’s what we’ve lined up for our
              first call—our way of keeping it focused and full of value.
            </Typography>
          </Box>
        </Box>
      </Grid2>
      <Grid2
        container
        alignItems={"center"}
        size={12}
        // spacing={{ xs: "1rem", md: "1rem" }}
        spacing={"1.5rem"}
        sx={{
          p: { xs: "1.5rem", md: "0rem 3rem 3rem 3rem" },
          maxWidth: { xs: "auto", xl: "2000px" },
        }}
      >
        <Grid2 container size={{ xs: 12, md: 6 }} spacing={"2.5rem"}>
          {questionList.map((listQues, i) => (
            <Grid2 key={i} size={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "1rem",
                  width: "100%",
                  cursor: "pointer",
                  p: 0.5,
                  color: question[listQues.state] ? commonCss.blue : "black",
                  borderBottom: question[listQues.state]
                    ? `2px solid ${commonCss.blue}`
                    : "2px solid #d6d6d6",
                  ":hover": {
                    color: commonCss.blue,
                    borderBottom: `2px solid ${commonCss.blue}`,
                  },
                }}
                onClick={() => {
                  handleCollapseOpen(listQues.state, !question[listQues.state]);
                }}
              >
                <Typography sx={{ fontSize: "1.15rem", color: "inherit" }}>
                  {listQues.questionName}
                </Typography>
                <IconButton
                  size="small"
                  aria-hidden="true"
                  tabIndex={-1}
                  sx={{
                    color: "inherit",
                    p: 0.2,
                  }}
                >
                  {question[listQues.state] ? (
                    <RemoveCircle sx={{ fontSize: "1.4rem" }} />
                  ) : (
                    <AddCircleOutline sx={{ fontSize: "1.4rem" }} />
                  )}
                </IconButton>
              </Box>
              <Collapse in={question[listQues.state]}>
                <Box sx={{ p: "1rem" }}>
                  <Typography sx={{ fontSize: "1rem" }}>
                    {listQues.answer}
                  </Typography>
                  <Box
                    sx={{
                      mt: "1.5rem",
                      display: listQues.listOfAns ? "flex" : "none",
                      flexDirection: "column",
                      gap: "0.5rem",
                    }}
                  >
                    {listQues.anslist.map((dataList, i) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          alignItems: "flex-start",
                        }}
                      >
                        <Done />
                        <Typography sx={{ fontSize: "1rem" }}>
                          <span style={{ fontWeight: 600 }}>
                            {dataList.title}
                          </span>
                          {dataList.answer}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Collapse>
            </Grid2>
          ))}
          <Grid2 size={12}>
            <Typography variant="h6" sx={{ mt: "2rem" }}>
              We serve a wide range of industries. Don’t hesitate to
              reach out to us:{" "}
              <span style={{ color: commonCss.blue }}>
                jobs@solverthoughts.com
              </span>
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
            <img src={"/Images/Partner/Outsourcing/FAQ.png"} alt="FAQ" style={{width:"100%"}}/>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default FAQ;
